<template>
    <div class="fc">
        <div class="detail">
            <h3 class="xxqk_tit">订单详情</h3>
            <img src="../../assets/close.png" class="xxqk_close" @click="$emit('closeLayer')">
            <h3 class="d_tit">订单信息</h3>
            <div class="flex d_li">
                <label class="d_lab">订单号</label>
                <p class="flex_item">{{detail.orderSn}}</p>
            </div>
            <div class="flex d_li">
                <label class="d_lab">下单时间</label>
                <p class="flex_item">{{detail.createTime}}</p>
            </div>
            <div class="flex d_li">
                <label class="d_lab">订单金额</label>
                <p class="flex_item clo_blue">{{detail.money}}</p>
            </div>
            <div class="flex d_li">
                <label class="d_lab">报名人</label>
                <p class="flex_item">{{detail.signList[0]?.nickName}}</p>
            </div>
            <div class="flex d_li">
                <label class="d_lab">支付方式</label>
                <p class="flex_item">{{showOrderMsg(detail.payType)}}</p>
            </div>
            <div class="flex d_li">
                <label class="d_lab">订单状态</label>
                <p class="flex_item">{{showOrderMsg(detail.orderStatus)}}</p>
            </div>
            <div class="flex d_li">
                <label class="d_lab">退款状态</label>
                <p class="flex_item">{{showOrderMsg(detail.refundFlag)}}</p>
            </div>
            <div class="flex d_li">
                <label class="d_lab">取消原因</label>
                <p class="flex_item">{{showOrderMsg(detail.cancelOf)}}</p>
            </div>
            <div class="flex d_li">
                <label class="d_lab">备注</label>
                <p class="flex_item">{{showOrderMsg(detail.remark)}}</p>
            </div>
            <h3 class="d_tit">发票信息</h3>
            <div class="flex d_li">
                <label class="d_lab">发票抬头</label>
                <p class="flex_item">{{detail.billName}}</p>
            </div>
            <div class="flex d_li">
                <label class="d_lab">单位税号</label>
                <p class="flex_item clo_blue">{{detail.taxCode}}</p>
            </div>
            <div class="flex d_li">
                <label class="d_lab">注册地址</label>
                <p class="flex_item">{{detail.billAddress}}</p>
            </div>
            <div class="flex d_li">
                <label class="d_lab">注册电话</label>
                <p class="flex_item">{{detail.billPhone}}</p>
            </div>
            <div class="flex d_li">
                <label class="d_lab">开户银行</label>
                <p class="flex_item">{{detail.bank}}</p>
            </div>
            <div class="flex d_li">
                <label class="d_lab">银行账号</label>
                <p class="flex_item">{{detail.bankAccount}}</p>
            </div>
            <div class="flex d_li">
                <label class="d_lab">收件姓名</label>
                <p class="flex_item">{{detail.collectName}}</p>
            </div>
            <div class="flex d_li">
                <label class="d_lab">收件电话</label>
                <p class="flex_item">{{detail.collectPhone}}</p>
            </div>
            <div class="flex d_li">
                <label class="d_lab">收件地址</label>
                <p class="flex_item">{{detail.collectAddress}}</p>
            </div>
            <div class="flex d_li">
                <label class="d_lab">收件邮箱</label>
                <p class="flex_item">{{detail.collectEmail}}</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        detail: {
            required: true,
        },
    },
    methods: {
        showOrderMsg(msg){
            let result = msg;
            if (msg === '' || msg === null || msg === '未退款') {
                result = '- -'
            }
            return result;
        }
    },
};
</script>

<style scoped>
.fc {
    position: fixed;
    top: 0px;
    bottom: 0px;
    left: 0px;
    right: 0px;
    background-color: rgba(0, 0, 0, .5);
    z-index: 999;
    display: block;
}

.detail {
    background-color: #fff;
    border-radius: 8px;
    padding: 32px 60px;
    width: 800px;
    box-sizing: border-box;
    margin: 0 auto;
    margin-top: 100px;
    position: relative;
    height: 80%;
    max-height: 800px;
    overflow-y: scroll;
}

.flex {
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    align-items: center;
}

.flex_item {
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    flex: 1;
    min-width: 0;
}

.xxqk_tit {
    font-size: 28px;
    font-weight: 600;
    color: #222;
    line-height: 40px;
    text-align: center;
}

.xxqk_close {
    width: 24px;
    height: 24px;
    position: absolute;
    top: 32px;
    right: 40px;
    cursor: pointer;
}

.d_tit {
    font-size: 20px;
    font-weight: 600;
    color: #222;
    line-height: 24px;
    padding-left: 17px;
    position: relative;
    margin-top: 32px;
}

.d_tit::before {
    content: "";
    position: absolute;
    top: 50%;
    left: 0px;
    width: 5px;
    height: 20px;
    margin-top: -10px;
    background-color: #003399;
    border-radius: 3px;
}

.d_li {
    font-size: 14px;
    color: #222;
    margin-top: 24px;
}

.d_lab {
    margin-right: 42px;
    text-align: right;
    width: 100px;
}

.clo_blue {
    color: #003399 !important;
}
</style>